import EnrolmentsSerializer from './base';

export default class Rollreturn extends EnrolmentsSerializer {}
